import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import Navbar from './Navbar';
import Footer from './Footer';

function Privacy() {
    const { t, lang } = useLanguage();

    const contentTR = (
        <>
            <section>
                <h2>1. Toplanan Veriler</h2>
                <p>Hizmetimizi kullanirken asagidaki verileri topluyoruz:</p>
                <ul>
                    <li><strong>Hesap Bilgileri:</strong> Ad, email adresi, sifre (sifrelenmis)</li>
                    <li><strong>Kullanim Verileri:</strong> Hesaplama gecmisi, tercihler, uygulama kullanim istatistikleri</li>
                    <li><strong>Teknik Veriler:</strong> IP adresi, tarayici turu, cihaz bilgisi</li>
                    <li><strong>Cerezler:</strong> Oturum yonetimi ve tercih saklamak icin</li>
                </ul>
            </section>

            <section>
                <h2>2. Verilerin Kullanimi</h2>
                <p>Toplanan veriler asagidaki amaclarla kullanilmaktadir:</p>
                <ul>
                    <li>Hesabinizi olusturmak ve yonetmek</li>
                    <li>Hizmeti sunmak ve iyilestirmek</li>
                    <li>Musteridesteği saglamak</li>
                    <li>Guvenlik ve dolandiricilik onleme</li>
                    <li>Yasal yukumlulukleri yerine getirmek</li>
                </ul>
            </section>

            <section>
                <h2>3. Veri Paylasimi</h2>
                <p>
                    Kisisel verilerinizi ucuncu taraflarla yalnizca asagidaki durumlarda paylasiyoruz:
                </p>
                <ul>
                    <li>Acik izniniz oldugunda</li>
                    <li>Yasal zorunluluk durumunda</li>
                    <li>Odeme islemcileri gibi hizmet saglayicilarla (yalnizca gerekli veriler)</li>
                </ul>
                <p>Verilerinizi hicbir zaman pazarlama amaciyla ucuncu taraflara satmiyoruz.</p>
            </section>

            <section>
                <h2>4. Veri Guvenligi</h2>
                <p>
                    Verilerinizi korumak icin endustri standartlarinda guvenlik onlemleri uyguluyoruz:
                </p>
                <ul>
                    <li>SSL/TLS sifreleme</li>
                    <li>Sifrelenmis veritabani depolama</li>
                    <li>Duzenli guvenlik denetimleri</li>
                    <li>Erisim kontrol mekanizmalari</li>
                </ul>
            </section>

            <section>
                <h2>5. Kullanici Haklari</h2>
                <p>KVKK ve GDPR kapsaminda asagidaki haklara sahipsiniz:</p>
                <ul>
                    <li><strong>Erisim Hakki:</strong> Hangi verilerinizi sakladigimizi ogrenme</li>
                    <li><strong>Duzeltme Hakki:</strong> Yanlis verilerin duzeltilmesini isteme</li>
                    <li><strong>Silme Hakki:</strong> Verilerinizin silinmesini talep etme</li>
                    <li><strong>Tasinabilirlik Hakki:</strong> Verilerinizi indirme</li>
                    <li><strong>Itiraz Hakki:</strong> Veri islemeye itiraz etme</li>
                </ul>
                <p>
                    Bu haklarinizi kullanmak icin <Link to="/support">destek sayfamizdan</Link> bizimle iletisime gecebilirsiniz.
                </p>
            </section>

            <section>
                <h2>6. Cerez Politikasi</h2>
                <p>Web sitemizde asagidaki cerez turlerini kullaniyoruz:</p>
                <ul>
                    <li><strong>Zorunlu Cerezler:</strong> Oturum yonetimi, guvenlik</li>
                    <li><strong>Tercih Cerezleri:</strong> Dil, tema secimi</li>
                    <li><strong>Analitik Cerezler:</strong> Kullanim istatistikleri (anonim)</li>
                </ul>
                <p>Tarayici ayarlarinizdan cerezleri yonetebilirsiniz.</p>
            </section>

            <section>
                <h2>7. Veri Saklama Suresi</h2>
                <p>
                    Verileriniz hesabiniz aktif oldugu surece saklanir. Hesabinizi sildiginizde, verileriniz
                    yasal gereklilikler haric 30 gun icinde tamamen silinir.
                </p>
            </section>

            <section>
                <h2>8. Cocuklarin Gizliligi</h2>
                <p>
                    Hizmetimiz 18 yas alti kullanicilar icin tasarlanmamistir. 18 yas alti bir kullanicinin
                    kayit oldugunu tespit edersek, hesabi ve iliskili tum verileri sileriz.
                </p>
            </section>

            <section>
                <h2>9. Iletisim</h2>
                <p>
                    Gizlilik politikamiz hakkinda sorulariniz icin <Link to="/support">destek sayfamizdan</Link> bizimle
                    iletisime gecebilirsiniz.
                </p>
            </section>
        </>
    );

    const contentEN = (
        <>
            <section>
                <h2>1. Data Collection</h2>
                <p>When using our service, we collect the following data:</p>
                <ul>
                    <li><strong>Account Information:</strong> Name, email address, password (encrypted)</li>
                    <li><strong>Usage Data:</strong> Calculation history, preferences, application usage statistics</li>
                    <li><strong>Technical Data:</strong> IP address, browser type, device information</li>
                    <li><strong>Cookies:</strong> For session management and preference storage</li>
                </ul>
            </section>

            <section>
                <h2>2. Use of Data</h2>
                <p>Collected data is used for the following purposes:</p>
                <ul>
                    <li>Creating and managing your account</li>
                    <li>Providing and improving the service</li>
                    <li>Providing customer support</li>
                    <li>Security and fraud prevention</li>
                    <li>Fulfilling legal obligations</li>
                </ul>
            </section>

            <section>
                <h2>3. Data Sharing</h2>
                <p>
                    We share your personal data with third parties only in the following situations:
                </p>
                <ul>
                    <li>When you have given explicit consent</li>
                    <li>When required by law</li>
                    <li>With service providers such as payment processors (only necessary data)</li>
                </ul>
                <p>We never sell your data to third parties for marketing purposes.</p>
            </section>

            <section>
                <h2>4. Data Security</h2>
                <p>
                    We implement industry-standard security measures to protect your data:
                </p>
                <ul>
                    <li>SSL/TLS encryption</li>
                    <li>Encrypted database storage</li>
                    <li>Regular security audits</li>
                    <li>Access control mechanisms</li>
                </ul>
            </section>

            <section>
                <h2>5. User Rights</h2>
                <p>Under GDPR, you have the following rights:</p>
                <ul>
                    <li><strong>Right of Access:</strong> Learn what data we store about you</li>
                    <li><strong>Right to Rectification:</strong> Request correction of incorrect data</li>
                    <li><strong>Right to Erasure:</strong> Request deletion of your data</li>
                    <li><strong>Right to Portability:</strong> Download your data</li>
                    <li><strong>Right to Object:</strong> Object to data processing</li>
                </ul>
                <p>
                    To exercise these rights, please contact us through our <Link to="/support">support page</Link>.
                </p>
            </section>

            <section>
                <h2>6. Cookie Policy</h2>
                <p>We use the following types of cookies on our website:</p>
                <ul>
                    <li><strong>Essential Cookies:</strong> Session management, security</li>
                    <li><strong>Preference Cookies:</strong> Language, theme selection</li>
                    <li><strong>Analytics Cookies:</strong> Usage statistics (anonymous)</li>
                </ul>
                <p>You can manage cookies through your browser settings.</p>
            </section>

            <section>
                <h2>7. Data Retention Period</h2>
                <p>
                    Your data is stored as long as your account is active. When you delete your account,
                    your data is completely deleted within 30 days, except for legal requirements.
                </p>
            </section>

            <section>
                <h2>8. Children's Privacy</h2>
                <p>
                    Our service is not designed for users under 18 years of age. If we discover that a user
                    under 18 has registered, we will delete the account and all associated data.
                </p>
            </section>

            <section>
                <h2>9. Contact</h2>
                <p>
                    For questions about our privacy policy, please contact us through our <Link to="/support">support page</Link>.
                </p>
            </section>
        </>
    );

    return (
        <div className="app-container">
            <Navbar />

            <main className="main-content">
                <div className="legal-page">
                    <div className="legal-header">
                        <h1>{t('legal.privacy')}</h1>
                        <p className="legal-updated">
                            {t('legal.lastUpdated')}: 01.01.2024
                        </p>
                    </div>

                    <div className="legal-content">
                        {lang === 'tr' ? contentTR : contentEN}
                    </div>
                </div>
            </main>

            <Footer />
        </div>
    );
}

export default Privacy;
